import { useEffect } from "react";
import { useImmer } from "use-immer";

/**
 * Whether the page OPENED on a saved draft that already differed from live —
 * the tab was closed or refreshed before Apply. Decided once, when the
 * comparison first settles, and cleared for good the moment the draft matches
 * live again (applied or discarded): an edit made in this visit is news, not a
 * warning.
 */
export const useOpenedWithUnappliedDraft = ({
  settled,
  hasSavedChanges,
}: {
  settled: boolean;
  hasSavedChanges: boolean;
}) => {
  const [state, setState] = useImmer<"pending" | "stale" | "fresh">("pending");
  useEffect(() => {
    if (!settled) {
      return;
    }
    setState((current) => {
      if (current === "pending") {
        return hasSavedChanges ? "stale" : "fresh";
      }
      return current === "stale" && !hasSavedChanges ? "fresh" : current;
    });
  }, [settled, hasSavedChanges, setState]);
  return state === "stale";
};
